import { Icon } from './Icon';
import styles from './PermissionLock.module.scss';

interface PermissionLockProps {
  label?: string;
  tooltip?: string;
  inline?: boolean;
}

// Petit badge "cadenas" — explicite quand une action requiert une permission
// que l'utilisateur courant n'a pas. Pour le POC c'est décoratif.
export function PermissionLock({ label = 'Requis', tooltip, inline }: PermissionLockProps) {
  return (
    <span
      className={[styles.lock, inline && styles.inline].filter(Boolean).join(' ')}
      title={tooltip}
    >
      <Icon name="lock" size={12} />
      {label}
    </span>
  );
}
